module.exports = __webpack_public_path__ + "img/environment6.cbf29955.png";